module.exports = __webpack_public_path__ + "static/img/11.02b260a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/sp/11.png
// module id = LHvD
// module chunks = 0